<template>
  <div class="container">
    <h3>Variable wählen...</h3>
    <div class="container mt-3">
      <b-button v-b-toggle.scriptout variant="primary">Skript Variablen</b-button>
      <b-collapse id="scriptout" class="mt-2">
        <ul class="list-group">
          <li v-for="(val,key) in variables.outputs" :key="key" class="list-group-item">
            {{ key }}<br/>
            <ul class="list-group float-right">
              <li v-for="(v,k) in val" :key="k" class="list-group-item" style="min-width:200px;">{{ k }}<br/><span class="text-muted" style="font-size:10pt;">{{ v.hint }}</span><button @click="selectVariable(key,v)" class="btn btn-sm btn-primary float-right">Auswählen</button></li>
            </ul>
          </li>
        </ul>
      </b-collapse>
    </div>
    <div class="container mt-3">
      <b-button v-b-toggle.datasourcelist variant="primary">Datenquellen</b-button>
      <b-collapse id="datasourcelist" class="mt-2">
        <ul class="list-group">
          <li v-for="(val,key) in variables.datasource" :key="key" class="list-group-item">{{ val.name }}<button @click="selectDataVar(val)" class="btn btn-sm btn-primary float-right">Auswählen</button></li>
        </ul>
      </b-collapse>
    </div>
  </div>
</template>

<script>
export default {
  props: ["graph","scripts","variables"],
  data() {
    return {
      search: '',
    };
  },
  methods: {
    selectDataVar(val) {
      console.log(val);
      this.$emit('selected',{ type:'data', value: val});
    },
    selectVariable(node,val) {
      console.log(val);
      this.$emit('selected',{type:'var',value: val,node: node });
    },
    updateSearch() {
      console.log('search: ' + this.search);
    },
    createDataList() {
      console.log('create new var list');
    }
  }
}
</script>
